export default __webpack_public_path__ + "static/media/SUI.cc1c1a6d.svg";